import { useMailbox } from "../hooks/useMailbox";
import { getFeatures } from "../features";

export function HomePage() {
  const mailItem = useMailbox();
  const features = getFeatures();

  return (
    <div className="flex flex-col gap-4">
      {mailItem ? (
        <>
          <div
            className="flex flex-col gap-1 pb-3"
            style={{ borderBottom: "1px solid var(--color-neutral-200)" }}
          >
            <p className="body-regular-medium" style={{ color: "var(--color-text)" }}>
              {mailItem.subject}
            </p>
            <p className="body-small" style={{ color: "var(--color-text-350)" }}>
              {mailItem.senderName || mailItem.senderEmail}
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="flex flex-col gap-2 rounded-xl p-3"
                style={{
                  border: "1px solid var(--color-neutral-200)",
                  background: "var(--color-neutral-50)",
                }}
              >
                <p className="body-small" style={{ color: "var(--color-text-350)" }}>
                  {feature.description}
                </p>
                <feature.Component
                  emailSubject={mailItem.subject}
                  emailBody={mailItem.body}
                  senderEmail={mailItem.senderEmail}
                  senderName={mailItem.senderName}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="body-regular" style={{ color: "var(--color-text-300)" }}>
          Select an email to get started.
        </p>
      )}
    </div>
  );
}
